import { Pipe, PipeTransform } from '@angular/core';

const CURRENCY_SYMBOL = 0;
const CURRENCY_RATE = 1;

@Pipe({
  name: 'toShortMetric',
  standalone: true,
})
export class ShortNumberPipe implements PipeTransform {
  transform(value: number, ...args: any[]): string {
    if (!value || Number.isNaN(value)) return null;

    const symbol = args[CURRENCY_SYMBOL];
    let rate = args[CURRENCY_RATE];

    if (!rate) {
      rate = 1;
    }

    const suffixes = ['', 'K', 'M', 'B', 'T'];

    const counter = Math.floor(Math.log10(value) / 3);

    const shortValue = (value * rate) / Math.pow(1000, counter);

    if (!args) return shortValue.toFixed(2) + suffixes[counter];

    return `${symbol || ''} ${shortValue.toFixed(2) + suffixes[counter]}`;
  }
}
